import styled from "styled-components";

export const BlueSeparator = styled.div`
  width: 55px;
  height: 5px;
  background-color: ${({ theme }) => theme.primary};
  border-radius: 2.5px;
  margin: 14px 0;
`;
